import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowDownToBracketThin = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 448 512",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M365.7 213.7l-136 136c-3.1 3.1-8.2 3.1-11.3 0l-136-136c-3.1-3.1-3.1-8.2 0-11.3s8.2-3.1 11.3 0L216 324.7 216 8c0-4.4 3.6-8 8-8s8 3.6 8 8l0 316.7L354.3 202.3c3.1-3.1 8.2-3.1 11.3 0s3.1 8.2 0 11.3zM16 328l0 96c0 39.8 32.2 72 72 72l272 0c39.8 0 72-32.2 72-72l0-96c0-4.4 3.6-8 8-8s8 3.6 8 8l0 96c0 48.6-39.4 88-88 88L88 512c-48.6 0-88-39.4-88-88l0-96c0-4.4 3.6-8 8-8s8 3.6 8 8z" })
});
export default SvgArrowDownToBracketThin;
